<template>
    <div class="w-layout-grid content-3-col-grid">
        <div class="side-content">
            <div class="fixed-parent assignable-roles">
                <div class="fixed pr-2">
                    <h4 class="">{{ trans('forms.training.Available Roles') }}</h4>
                    <div class="form-inline">
                        <input class="form-control mr-1" type="search" :placeholder="trans('forms.search')" aria-label="Search"
                               v-model="assignableRolesSearch" @input="searchAssignableRoles()" @keydown.enter="getAssignableRoles()">
<!--                        <button @click="getAssignableRoles()" class="btn btn-outline-success my-2 my-sm-0"-->
<!--                                type="button">{{ trans('training.add_training_search') }}-->
<!--                        </button>-->
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <draggable
                                :clone="cloneAssignableRole"
                                tag="div"
                                :group="{
                                            name: 'assignableRoleList',
                                            pull: 'clone',
                                            put: false,
                                        }"
                                :list="assignableRoles"
                                :move="checkRoleNotAssigned"
                                :sort="false"
                                class="training-side-lists">
                                <div
                                    class="text-left pl-0 pr-0 mt-2 pointer"
                                    v-for="(element, idx) in assignableRoles"
                                    :key="'assignable-role-'+idx"
                                >
                                    <i class="fa fa-user-tag"></i>
                                    <span class="text">{{ element.name }} </span>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fixed-parent student-groups">
                <div class="fixed pr-2 border-top">
                    <h4 class="mt-3">{{ trans('forms.training.Student Groups') }}</h4>
                    <div class="form-inline">
                        <input class="form-control mr-1" type="search" :placeholder="trans('forms.search')" aria-label="Search"
                               v-model="studentGroupsSearch" @input="searchStudentGroups()" @keydown.enter="getStudentGroups()">
<!--                        <button @click="getStudentGroups()" class="btn btn-outline-success my-2 my-sm-0"-->
<!--                                type="button">{{ trans('training.add_training_search') }}-->
<!--                        </button>-->
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <draggable
                                :clone="cloneStudentGroup"
                                tag="div"
                                :group="{ name: 'studentGroupList',
                                            pull: 'clone',
                                            put: false }"
                                :list="studentGroups"
                                :move="checkStudentGroupNotAssigned"
                                class="training-side-lists">
                                <div
                                    class="text-left pl-0 pr-0 mt-2 pointer"
                                    v-for="(element, idx) in studentGroups"
                                    :key="'student-group-'+idx"
                                >
                                    <i class="fa fa-users"></i>
                                    <span class="text">{{ element.name }} </span>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle-content middle-content-initial-state">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="form-group">
                        <label class="col-form-label" for="trainingTitle">{{ trans('forms.training.title_placeholder') }}</label>
                        <input
                            type="text"
                            @change="saveTraining()"
                            class="form-control"
                            :class="{'is-invalid': errors && errors.title}"
                            id="trainingTitle"
                            placeholder=""
                            v-model="training.title"
                        >
                        <span v-if="errors && errors.title" class="invalid-feedback" role="alert">
                                <strong v-for="error in errors.title">
                                    {{ error }}
                                </strong>
                            </span>
                    </div>
                </div>
                <div class="col-6 col-xl-3">
                    <div class="form-group">
                        <label class="col-form-label" for="training_start_at">{{ trans('training.add_training_start_date') }}</label>
                        <input @change="trainingStartDateChanged()"
                               id="training_start_at"
                               class="form-control training-date"
                               v-model="training.start_at"
                               type="date"/>
                    </div>
                </div>
                <div class="col-6 col-xl-3">
                    <div class="form-group">
                        <label class="col-form-label" for="training_end_at">{{ trans('training.add_training_end_date') }}</label>
                        <input @change="trainingEndDateChanged()"
                               id="training_end_at"
                               class="form-control training-date"
                               v-model="training.end_at"
                               type="date"/>
                    </div>
                </div>
            </div>
            <div v-if="training.id" class="row d-flex flex-wrap">
                <div class="col-12 training-column-block">
                    <h4 class="mt-2">{{ trans('messages.Course') }}</h4>
                    <div v-if="(!training.course_id || !course) && doneLoadingTraining" class="col-12 border">
                        <div class="form-group align-items-center" style="margin-top: 1rem">
                            <select id="courseId" class="form-control" v-model="training.course_id"
                                    @change="selectCourseConfirm($event)">
                                <option value="null" disabled selected>{{ trans('messages.Select Course') }}</option>
                                <option v-for="course in selectCourses" :value="course.id">{{ course.name }}</option>
                            </select>
                        </div>
                        <div v-if="displayNoCoursesMessage" class="alert alert-danger" v-html="trans('messages.No courses available for training')"></div>
                    </div>
                    <div v-else-if="course && doneLoadingTraining" class="col-12 border pb-2 training-course-block">
                        <div v-if="false" class="form-inline mt-2">
                            <!--                            <div class="col-sm-6 form-group mb-0 p-0 pr-1">-->
                            <!--                                <label for="course_available_from">{{ trans('forms.training.Available from') }}</label>-->
                            <!--                                <input @change="saveTraining()"-->
                            <!--                                       v-model="training.course_available_from"-->
                            <!--                                       id="course_available_from"-->
                            <!--                                       type="date"-->
                            <!--                                       :max="maxCourseAvailability"-->
                            <!--                                       class="form-control col-sm-12"/>-->
                            <!--                            </div>-->
                            <!--                            <div class="col-sm-6 form-group mb-0 p-0 pl-1">-->
                            <!--                                <label for="course_available_to">{{ trans('forms.training.Available until') }}</label>-->
                            <!--                                <input @change="saveTraining()"-->
                            <!--                                       v-model="training.course_available_to"-->
                            <!--                                       id="course_available_to"-->
                            <!--                                       type="date"-->
                            <!--                                       :min="minCourseAvailability"-->
                            <!--                                       class="form-control col-sm-12"/>-->
                            <!--                            </div>-->
                        </div>
                        <div class="mt-2">
                            <select id="courseIdSelected" class="form-control" disabled>
                                <option :value="training.course_id">{{ course.name }}</option>
                            </select>
                        </div>
                        <div class="training-course-section-block mt-2">
                            <div v-for="section in course.sections" class="list-group-item course-section">
                                <h5 :class="'training-course-chapter-level-'+section.section_type">{{ section.name }}</h5>
                                <draggable
                                    handle=".handle"
                                    swap-threshold="0.5"
                                    :scroll="true"
                                    :scroll-speed="2000"
                                    :scroll-sensitivity="10"
                                    @change="changeTrainingCourseEventsSchedule($event,section.id)"
                                    tag="div"
                                    :group="{name: 'courseEventsList',}"
                                    v-model="courseEventsSchedule[section.id]"
                                    class="course-events-section-area">
                                    <div class="list-group-item course-event-group-item"
                                         v-for="(element,idx) in courseEventsSchedule[section.id]"
                                         :key="'training-course-event-'+idx">
                                        <div class="position-relative">
                                            <i class="far fa-calendar-alt handle"></i>
                                            <span class="text mx-2">{{ element.name }} </span>
                                            <button v-if="element.scheduling !== 'none' && element.start_at"
                                                    class="btn btn-sm btn-outline-secondary inner-card-small-button"
                                                    @click="editCourseEventSchedule(section.id, element)">
                                                {{ moment(element.start_at).format('DD.MM.YYYY') }}
                                                <template v-if="element.end_at">
                                                    - {{ moment(element.end_at).format('DD.MM.YYYY') }}
                                                </template>
                                            </button>
                                            <i class="fa fa-times close"
                                               @click="removeCourseEventAt(section.id,idx)"></i>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                    <template v-if="course">
                        <h4 class="mt-2">{{ trans('forms.training.Training Roles') }}</h4>
                        <div class="col-12 border pb-4 training-roles-block">
                            <draggable
                                handle=".handle"
                                @change="changeTrainingRoles($event)"
                                :swapThreshold="0.5"
                                :sort="false"
                                :scroll="true"
                                :scroll-speed="2000"
                                :scroll-sensitivity="10"
                                tag="div"
                                :group="{name: 'assignableRoleList',}"
                                v-model="trainingRoles"
                                class="roles-section-area">
                                <div v-for="(element,idx) in trainingRoles" :key="'training-role-'+idx"
                                     class="list-group-item role-list-group-item">
                                    <div class="position-relative">
                                        <i class="fa fa-user-tag handle"></i>
                                        <span class="text mx-2">{{ element.name }} </span>
                                        <button class="btn btn-sm btn-outline-secondary inner-card-small-button"
                                                @click="trainingRoleUsersModalRole = element.id; showTrainingRoleUsersModal = true">
                                            {{ element.user_count }} {{ trans('messages.Users selected') }}
                                        </button>
                                        <i class="fa fa-times close" @click="removeRoleAt(idx)"></i>
                                        <template v-if="element.users">
                                            <a class="expander collapsed" data-toggle="collapse"
                                               :href="'#role-user-collapse'+element.id" role="button" aria-expanded="false"
                                               :aria-controls="'role-user-collapse'+element.id">
                                                <i class="fas fa-angle-down map-icon-150 pt-1"></i>
                                            </a>
                                            <div class="collapse inner-card-section-collapsible" :id="'role-user-collapse'+element.id">
                                                <div class="card card-body role-users-card">
                                                    <div v-for="roleUser in element.users" class="inner-card-section-row">
                                                        <i class="fa fa-user"></i>
                                                        {{ roleUser.first_name }} {{ roleUser.last_name }}
                                                        <button v-if="element.assignableToUser" class="btn btn-sm btn-outline-secondary inner-card-small-button float-right"
                                                                @click="openTRUStudentsModal(roleUser, element.name)">
                                                            {{ roleUser.student_count }} {{ trans('messages.Assign students') }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </draggable>
                        </div>

                        <h4 class="mt-2">{{ trans('forms.training.Training Student Groups') }}</h4>
                        <div class="col-12 border pb-4 training-student-groups-block">
                            <draggable
                                handle=".handle"
                                :sort="false"
                                @change="changeStudentGroups($event)"
                                swapThreshold="0.5"
                                :scroll="true"
                                :scroll-speed="2000"
                                :scroll-sensitivity="10"
                                tag="div"
                                :group="{name: 'studentGroupList',}"
                                v-model="trainingStudentGroups"
                                class="training-student-section-area">
                                <div v-for="(element,idx) in trainingStudentGroups" :key="'training-student-group-'+idx"
                                     class="list-group-item student-group-list-item">
                                    <div>
                                        <div class="position-relative card-list-row">
                                            <i class="fa fa-users"></i>
                                            <span class="text mx-2" :title="element.name">{{ element.name }} </span>
                                            <button class="btn btn-sm btn-outline-secondary inner-card-small-button ml-auto"
                                                    @click="modalStudentGroup = element; showStudentGroupStudentsModal = true">
                                                {{ element.student_count }} {{ trans('messages.Students') }}
                                            </button>
                                            <i class="fa fa-times close" @click="removeStudentGroupAt(idx)"></i>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>

                        <h4 class="mt-2">{{ trans('forms.training.Training Students') }}</h4>
                        <div class="col-12 border pb-4 training-students-block">
                            <draggable
                                handle=".handle"
                                :sort="false"
                                @change="changeStudents($event)"
                                swapThreshold="0.5"
                                :scroll="true"
                                :scroll-speed="2000"
                                :scroll-sensitivity="10"
                                tag="div"
                                :group="{name: 'studentList',}"
                                v-model="trainingStudents"
                                class="training-student-section-area">
                                <div v-for="(element,idx) in trainingStudents" :key="'training-student-group-'+idx"
                                     class="list-group-item student-group-list-item">
                                    <div>
                                        <div class="position-relative">
                                            <i class="fa fa-user"></i>
                                            <span class="text mx-2">{{ element.name }} </span>
                                            <i class="fa fa-times close" @click="removeStudentAt(idx)"></i>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="side-content right side-right-initial-state">
            <div class="fixed-parent course-events">
                <div class="fixed pr-2">
                    <h4 class="">{{ trans('forms.training.Course Events') }}</h4>
                    <div class="form-inline">
                        <input class="form-control mr-1" type="search" :placeholder="trans('forms.search')" aria-label="Search"
                               v-model="courseEventSearch" @input="searchCourseEvents()" @keydown.enter="getCourseEvents()">
<!--                        <button @click="getCourseEvents()" class="btn btn-outline-success my-2 my-sm-0"-->
<!--                                type="button">{{ trans('training.add_training_search') }}-->
<!--                        </button>-->
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <draggable
                                :clone="cloneCourseEvent"
                                tag="div"
                                :group="{ name: 'courseEventsList',
                                            pull: 'clone',
                                            put: false }"
                                v-model="courseEvents"
                                class="training-side-lists"
                            >
                                <div
                                    class="text-left pl-0 pr-0 mt-2 pointer"
                                    v-for="(element, idx) in courseEvents"
                                    :key="'course-event-'+idx"
                                >
                                    <i class="far fa-calendar-alt"></i>
                                    <span class="text">{{ element.name }} </span>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fixed-parent student-groups">
                <div class="fixed pr-2 border-top">
                    <h4 class="mt-3">{{ trans('forms.training.Students') }}</h4>
                    <div class="form-inline">
                        <input class="form-control mr-1" type="search" :placeholder="trans('forms.search')" aria-label="Search"
                               v-model="studentsSearch" @input="searchStudents()" @keydown.enter="getStudents()">
<!--                        <button @click="getStudents()" class="btn btn-outline-success my-2 my-sm-0"-->
<!--                                type="button">{{ trans('training.add_training_search') }}-->
<!--                        </button>-->
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <draggable
                                :clone="cloneStudent"
                                tag="div"
                                :group="{ name: 'studentList',
                                            pull: 'clone',
                                            put: false }"
                                :list="students"
                                :move="checkStudentNotAssigned"
                                class="training-side-lists">
                                <div
                                    class="text-left pl-0 pr-0 mt-2 pointer"
                                    v-for="(element, idx) in students"
                                    :key="'student-'+idx"
                                >
                                    <i class="fa fa-user"></i>
                                    <span class="text">{{ element.name }} </span>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="showTrainingRoleUsersModal">
            <training-role-users-modal @update-training-role-users="updateTrainingRoleUsers"
                                       :training="training.id"
                                       :role="trainingRoleUsersModalRole"
            ></training-role-users-modal>
        </template>
        <template v-if="showCourseEventDatesModal">
            <course-events-dates-modal :course-event="modalCourseEvent"
                                       :training="this.training"
                                       :event-reminder-emails="eventReminderEmails"
                                       :completion-missed-emails="completionMissedEmails"
                                       @update-course-event="updateCourseEventElement"
            ></course-events-dates-modal>
        </template>
        <template v-if="showStudentGroupStudentsModal">
            <student-group-students-modal :student-group="modalStudentGroup"
                                          @modal-closed="showStudentGroupStudentsModal=false"></student-group-students-modal>
        </template>
        <template v-if="showTrainingRoleUserStudentsModal">
            <training-role-user-students-modal :user="trainingRoleUserStudentsModalUser"
                                               :role-name="trainingRoleUserStudentsModalRoleName"
                                               :training="training.id"
                                               @modal-closed="showTrainingRoleUserStudentsModal=false"></training-role-user-students-modal>
        </template>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import TrainingRoleUsersModal from "./TrainingEditorComponents/TrainingRoleUsersModal";
import CourseEventsDatesModal from "./TrainingEditorComponents/CourseEventDatesModal";
import StudentGroupStudentsModal from "./TrainingEditorComponents/StudentGroupStudentsModal";
import TrainingRoleUserStudentsModal from "./TrainingEditorComponents/TrainingRoleUserStudentsModal";
import moment from "moment";

export default {
    name: "TrainingEditor",
    components: {
        StudentGroupStudentsModal,
        CourseEventsDatesModal,
        TrainingRoleUsersModal,
        TrainingRoleUserStudentsModal,
        draggable
    },
    props: {
        trainingId: {
            type: Number,
        },
        eventReminderEmails: Object,
        completionMissedEmails: Object,
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        training: {
            id: 0,
            title: "",
            start_at: "",
            end_at: "",
            course_available_from: "",
            course_available_to: "",
            course_id: null,
        },
        trainingRoles: [],
        errors: {},
        isEdit: false,
        doneLoadingTraining: false,
        students: [],
        studentsSearch: "",
        studentGroups: [],
        studentGroupsSearch: "",
        courseEvents: [],
        courseEventSearch: "",
        assignableRoles: [],
        assignableRolesSearch: "",
        showTrainingRoleUsersModal: false,
        trainingRoleUsersModalRole: 0,
        selectCourses: null,
        course: null,
        courseEventsSchedule: {},
        showCourseEventDatesModal: false,
        modalCourseEvent: {},
        trainingStudentGroups: [],
        trainingStudents: [],
        showStudentGroupStudentsModal: false,
        modalStudentGroup: {},
        showTrainingRoleUserStudentsModal: false,
        trainingRoleUserStudentsModalUser: {},
        trainingRoleUserStudentsModalRoleName: "",
        moment: moment,
    }),
    created() {
        this.training.id = this.trainingId
        this.getTraining()
        this.getAssignableRoles()
        this.getCourseEvents()
        this.getStudentGroups()
        this.getStudents()

    },
    mounted() {
        this.getTrainingRoles()
        this.getTrainingStudentGroups()
        this.getTrainingStudents()
    },
    computed: {
        // minCourseAvailability: function () {
        //     if (this.training.course_available_from) {
        //         return this.training.course_available_from
        //     } else {
        //         return this.training.start_at
        //     }
        // },
        // maxCourseAvailability: function () {
        //     if (this.training.course_available_to) {
        //         return this.training.course_available_to
        //     } else {
        //         return this.training.end_at
        //     }
        // }
        displayNoCoursesMessage: function () {
            return this.selectCourses !== null && this.selectCourses.length === 0;
        }
    },
    methods: {
        saveTraining(withRefresh = false) {
            this.errors = {};
            if (this.training.title === null
                || this.training.title.length === 0
                || this.training.start_at === null
                || this.training.start_at.length === 0
                || this.training.end_at === null
                || this.training.end_at.length === 0) {
                return
            }
            // console.log(this.training)
            let url = "/training"
            let method = "post"
            if (this.training.id) {
                url = "/training/" + this.training.id
                method = "patch"
            }
            axios[method](
                url,
                this.training,
            ).then(response => {
                if (!this.training.id) {
                    location.href = response.data.redirect
                } else {
                    //console.log(response.data)
                    this.training = response.data.training
                    if (withRefresh) {
                        this.getTraining()
                    }
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    //console.log(this.errors)
                }
            });
        },
        searchCourseEvents() {
            if (this.courseEvents.length < 1000 && (this.courseEventSearch.length >= 2 || this.courseEventSearch.length === 0)) {
                this.getCourseEvents()
            }
        },
        getCourseEvents: function () {
            let $end = '/admin/course-event/';
            let self = this;
            axios.get($end, {params: {search: this.courseEventSearch}}).then(function (response) {
                response = response.data;
                self.courseEvents = [];

                response.data.forEach(function (courseEvent) {
                    let data = {
                        // id: 0 ,
                        id: courseEvent.id,
                        name: courseEvent.name,
                        description: courseEvent.description ? courseEvent.description : '',
                        scheduling: courseEvent.scheduling,
                    }
                    self.courseEvents.push(data);
                });

            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        cloneCourseEvent({id, name, description, scheduling}) {
            return {
                course_event_id: id,
                name: name,
                description: description,
                scheduling: scheduling,
                clone: true,
            }
        },
        searchAssignableRoles() {
            if (this.assignableRoles.length < 1000 && (this.assignableRolesSearch.length >= 2 || this.assignableRolesSearch.length === 0)) {
                this.getAssignableRoles()
            }
        },
        getAssignableRoles() {
            let $end = '/api/training-assignable-roles';
            let self = this;
            axios.get($end, {params: {search: this.assignableRolesSearch}}).then(function (response) {
                response = response.data;
                self.assignableRoles = [];

                response.data.forEach(function (assignableRole) {
                    let data = {
                        id: assignableRole.id,
                        name: assignableRole.name,
                        description: assignableRole.description ? assignableRole.description : '',
                        user_count: 0,
                    }
                    self.assignableRoles.push(data);
                });

            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        cloneAssignableRole({id, name, description}) {
            return {
                id: id,
                name: name,
                description: description,
                user_count: 0,
                clone: true,
            }
        },
        searchStudentGroups() {
            if (this.studentGroups.length < 1000 && (this.studentGroupsSearch.length >= 2 || this.studentGroupsSearch.length === 0)) {
                this.getStudentGroups()
            }
        },
        getStudentGroups() {
            let $end = '/api/student-groups';
            let self = this;
            axios.get($end, {params: {search: this.studentGroupsSearch}}).then(function (response) {
                response = response.data;
                self.studentGroups = [];

                response.data.forEach(function (studentGroup) {
                    let data = {
                        id: studentGroup.id,
                        name: studentGroup.name,
                        description: studentGroup.description ? studentGroup.description : '',
                        student_count: studentGroup.students.length,
                        students: studentGroup.students
                    }
                    self.studentGroups.push(data);
                });

            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        cloneStudentGroup({id, name, description, student_count, students}) {
            // console.log({id, name, description, students})
            return {
                id: id,
                name: name,
                description: description,
                student_count: student_count,
                students: students,
                clone: true,
            }
        },
        searchStudents() {
            if (this.students.length < 1000 && (this.studentsSearch.length >= 2 || this.studentsSearch.length === 0)) {
                this.getStudents()
            }
        },
        getStudents() {
            let $end = '/api/students';
            let self = this;
            axios.get($end, {params: {search: this.studentsSearch}}).then(function (response) {
                response = response.data;
                self.students = [];

                response.data.forEach(function (student) {
                    let data = {
                        id: student.id,
                        name: student.full_name,
                    }
                    self.students.push(data);
                });

            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        cloneStudent({id, name}) {
            return {
                id: id,
                name: name,
                clone: true,
            }
        },
        changeTrainingRoles(event) {
            if (!this.training.id) {
                return false
            }
            if (event.added || event.removed) {
                let $end = '/api/training-roles/' + this.training.id
                axios.put($end, this.trainingRoles).then(function () {
                    // response = response.data
                    // console.log(response.data)
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        checkRoleNotAssigned(event) {
            return !this.trainingRoles.filter(e => e.id === event.draggedContext.element.id).length
        },
        removeRoleAt(idx) {
            this.$swal.fire({
                title: trans.messages["Are you sure you want to remove this role and it's assignments?"],
                icon: 'warning',
                html: '',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.trainingRoles.splice(idx, 1)
                    this.changeTrainingRoles({removed: true})
                }
            });
        },
        updateTrainingRoleUsers(result) {
            if (result.update) {
                this.getTrainingRoles()
            }

            this.showTrainingRoleUsersModal = false
        },
        getTrainingRoles() {
            if (this.training.id > 0) {
                let $end = '/api/training-roles/' + this.training.id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.trainingRoles = [];
                    // console.log(response.data)
                    response.data.forEach(function (trainingRole) {
                        let data = {
                            id: trainingRole.id,
                            name: trainingRole.name,
                            description: trainingRole.description,
                            user_count: trainingRole.user_count,
                            users: trainingRole.users,
                            assignableToUser: trainingRole.assignable_to_user,
                        }
                        self.trainingRoles.push(data);
                    });

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        getTraining() {
            if (this.training.id > 0) {
                let $end = '/training/' + this.training.id
                let self = this
                axios.get($end).then(function (response) {
                    response = response.data;
                    // console.log(response)
                    self.training.course_id = response.course_id
                    self.training.start_at = response.start_at
                    self.training.end_at = response.end_at
                    self.training.title = response.title
                    self.training.course_available_from = response.course_available_from
                    self.training.course_available_to = response.course_available_to

                    if (!self.training.course_id) {
                        let $end = '/api/courses/'
                        let sorting = []
                        sorting.push({
                            field: "name",
                            direction: "asc"
                        })
                        axios.get($end,{params: {sort: sorting}}).then(function (response) {
                            response = response.data;
                            self.selectCourses = response.data
                            self.doneLoadingTraining = true
                        })
                    } else {
                        let $end = '/api/get-course-api/' + self.training.course_id
                        axios.get($end).then(function (response) {
                            response = response.data;
                            self.course = response.course
                            self.course.sections.forEach(function (section) {
                                self.courseEventsSchedule[section.id] = []
                            })
                            self.getTrainingCourseEventsSchedule()
                            self.doneLoadingTraining = true
                        })
                    }
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        selectCourseConfirm() {
            let self = this
            let course = this.selectCourses.filter(element => element.id === this.training.course_id).pop()
            let courseData = trans.messages["program_course_title_modal"] + course.name
            if (course.category) {
                courseData += '<br>' + trans.messages["program_course_category_modal"] + course.category.name
            }
            if (course.description) {
                courseData += '<br>' + trans.messages["program_course_description_modal"] + course.description
            }
            // console.log(course)
            this.$swal.fire({
                title: trans.messages["Select this course? This cannot be changed later"],
                icon: 'warning',
                html: courseData,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    //set initial values for course availability
                    this.training.course_available_from = this.training.start_at;
                    this.training.course_available_to = this.training.end_at;
                    this.saveTraining(true)
                } else {
                    self.training.course_id = null
                }
            });
        },
        changeTrainingCourseEventsSchedule(event, sectionId) {
            //console.log(event)
            this.$forceUpdate()
            if (event && typeof event.added != 'undefined') {
                this.courseEventsSchedule[sectionId][event.added.newIndex].section_id = sectionId
                if (event.added.element.scheduling !== "none" && typeof event.added.element.start_at === "undefined") {
                    this.modalCourseEvent = event.added.element
                    this.modalCourseEventIndex = event.added.newIndex
                    this.modalCourseEventSection = sectionId
                    this.showCourseEventDatesModal = true
                    //saving will be done after modal closes
                    return false
                } else if (event.added.element.scheduling === "none" && typeof event.added.element.start_at === "undefined") {
                    //this will prevent firing save twice when moving no schedule events
                    this.courseEventsSchedule[sectionId][event.added.newIndex].start_at = null
                    this.saveTrainingCourseEventsSchedule()
                }
            }
            if (event && (typeof event.moved != 'undefined' || typeof event.removed != 'undefined')) {
                this.saveTrainingCourseEventsSchedule()
            }
            // console.log(this.courseEventsSchedule)
        },
        removeCourseEventAt(sectionId, idx) {
            this.$swal.fire({
                title: trans.messages["Are you sure you want to remove this event from this course program?"],
                icon: 'warning',
                html: '',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.courseEventsSchedule[sectionId].splice(idx, 1)
                    this.changeTrainingCourseEventsSchedule({removed: true}, sectionId)
                }
            });
        },
        editCourseEventSchedule(sectionId, element) {
            this.modalCourseEvent = element
            this.modalCourseEventSection = sectionId
            this.modalCourseEventIndex = this.courseEventsSchedule[sectionId].indexOf(element)
            this.showCourseEventDatesModal = true
        },
        updateCourseEventElement(result) {
            if (!result.save && !this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].start_at) {
                this.courseEventsSchedule[this.modalCourseEventSection].splice(this.modalCourseEventIndex, 1);
            } else if (result.save) {
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].start_at = result.start_at;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].end_at = result.end_at;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].completion_missed_email = result.completion_missed_email;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].event_reminder_email = result.event_reminder_email;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].start_at_time = result.start_at_time;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].additional_info = result.additional_info;
                this.courseEventsSchedule[this.modalCourseEventSection][this.modalCourseEventIndex].reminders = result.reminders;
                this.saveTrainingCourseEventsSchedule()
            }
            this.modalCourseEvent = null
            this.modalCourseEventIndex = null
            this.modalCourseEventSection = null
            this.showCourseEventDatesModal = false

        },
        saveTrainingCourseEventsSchedule() {
            //this is being called twice when moving
            // console.log('saved')
            if (!this.training.id) {
                return false
            }

            let $end = '/api/course-event-schedule/' + this.training.id
            let self = this
            // console.log(this.courseEventsSchedule)
            axios.put($end, this.courseEventsSchedule).then(function () {
                // response = response.data
                // console.log(response.data)
                self.getTrainingCourseEventsSchedule()
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });

        },
        getTrainingCourseEventsSchedule() {
            if (this.training.id > 0) {
                let $end = '/api/course-event-schedule/' + this.training.id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.course.sections.forEach(function (section) {
                        self.courseEventsSchedule[section.id] = []
                    })
                    response.data.forEach(function (courseEventSchedule) {
                        let data = {
                            id: courseEventSchedule.id,
                            course_event_id: courseEventSchedule.courseEvent.id,
                            name: courseEventSchedule.courseEvent.name,
                            scheduling: courseEventSchedule.courseEvent.scheduling,
                            section_id: courseEventSchedule.section_id,
                            start_at: courseEventSchedule.start_at,
                            end_at: courseEventSchedule.end_at,
                            completion_missed_email: courseEventSchedule.completion_missed_email,
                            event_reminder_email: courseEventSchedule.event_reminder_email,
                            start_at_time: courseEventSchedule.start_at_time,
                            additional_info: courseEventSchedule.additional_info,
                            reminders: courseEventSchedule.reminders,
                        }
                        self.courseEventsSchedule[data.section_id].push(data)

                    });
                    self.$forceUpdate()
                    // console.log(self.courseEventsSchedule)

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        trainingStartDateChanged() {
            if (this.training.id && this.training.course_id) {
                this.$swal.fire(trans.messages['Training schedule changed!'], trans.messages['training_schedule_reschedule_others_reminder'], 'success')
                this.training.course_available_from = this.training.start_at
            }
            $('#training_end_at').prop('min', this.training.start_at)
            this.saveTraining()
        },
        trainingEndDateChanged() {
            if (this.training.id && this.training.course_id) {
                this.$swal.fire(trans.messages['Training schedule changed!'], trans.messages['training_schedule_reschedule_others_reminder'], 'success')
                this.training.course_available_to = this.training.end_at
            }
            $('#training_start_at').prop('max', this.training.end_at)
            this.saveTraining()
        },
        changeStudentGroups(event) {
            if (!this.training.id) {
                return false
            }

            if (event.added || event.removed) {
                let $end = '/api/training-student-groups/' + this.training.id
                axios.put($end, this.trainingStudentGroups).then(function () {
                    // response = response.data
                    // console.log(response.data)
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        removeStudentGroupAt(idx) {
            this.$swal.fire({
                title: trans.messages["Are you sure you want to remove this group from this course program?"],
                icon: 'warning',
                html: '',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.trainingStudentGroups.splice(idx, 1)
                    this.changeStudentGroups({removed: true})
                }
            })
        },
        changeStudents(event) {
            if (!this.training.id) {
                return false
            }

            if (event.added || event.removed) {
                let $end = '/api/training-students/' + this.training.id
                axios.put($end, this.trainingStudents).then(function () {
                    // response = response.data
                    // console.log(response.data)
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        removeStudentAt(idx) {
            this.$swal.fire({
                title: trans.messages["Are you sure you want to remove this student from this course program?"],
                icon: 'warning',
                html: '',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.trainingStudents.splice(idx, 1)
                    this.changeStudents({removed: true})
                }
            })
        },
        checkStudentNotAssigned(event) {
            return !this.trainingStudents.filter(e => e.id === event.draggedContext.element.id).length
        },
        checkStudentGroupNotAssigned(event) {
            return !this.trainingStudentGroups.filter(e => e.id === event.draggedContext.element.id).length
        },
        getTrainingStudentGroups() {
            if (this.training.id > 0) {
                let $end = '/api/training-student-groups/' + this.training.id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.trainingStudentGroups = [];
                    // console.log(response.data)
                    response.data.forEach(function (trainingStudentGroup) {
                        let data = {
                            id: trainingStudentGroup.id,
                            name: trainingStudentGroup.name,
                            description: trainingStudentGroup.description,
                            student_count: trainingStudentGroup.students.length,
                            students: trainingStudentGroup.students,
                        }
                        self.trainingStudentGroups.push(data);
                    });

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        getTrainingStudents() {
            if (this.training.id > 0) {
                let $end = '/api/training-students/' + this.training.id;
                let self = this;
                axios.get($end).then(function (response) {
                    response = response.data;
                    self.trainingStudents = [];
                    // console.log(response.data)
                    response.data.forEach(function (trainingStudent) {
                        let data = {
                            id: trainingStudent.id,
                            first_name: trainingStudent.first_name,
                            last_name: trainingStudent.last_name,
                            name: trainingStudent.first_name + " " + trainingStudent.last_name
                        }
                        self.trainingStudents.push(data);
                    });

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            }
        },
        openTRUStudentsModal(roleUser, roleName) {
            this.trainingRoleUserStudentsModalUser = roleUser;
            this.trainingRoleUserStudentsModalRoleName = roleName;
            this.showTrainingRoleUserStudentsModal = true
        }
    }
}
</script>

<style scoped>
.handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: small;
}

.text {
    margin-left:3px
}

.list-group-item.role-list-group-item, .list-group-item.course-event-group-item {
    padding: 0.25em 1em;
}

.roles-section-area, .training-student-section-area {
    margin-top: 0.5rem;
    min-height: 100px;
    height: 90%;
}

.role-users-card {
    max-height: 100px;
    overflow-y: auto;
    padding: 0.5em !important;
}

.expander {
    float: right;
    /*font-size: 1.35rem;*/
    /*font-weight: 700;*/
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
    margin-right: 50px;
}

[data-toggle="collapse"] i {
    display: inline-block;
    font-size: 1.35rem;
    font-weight: 900;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: rotate(-180deg);
    transition: all linear 0.25s;
}

[data-toggle="collapse"].collapsed i {
    transform: rotate(0deg);
}

.list-group-item.course-section {
    padding: 0.5em !important;
}


.training-roles-block, .training-student-groups-block {
    height: auto;
    overflow-y: auto;
}

.training-course-block {
    height: auto;
    overflow-y: auto;
}

.training-students-block {
    height: auto;
    overflow-y: auto;
}

.training-course-section-block {
    height: auto;
    overflow-y: auto;
}

.training-column-block {
    height: auto;

}


.inner-card-small-button {
    height: auto;
    min-height: unset;
    padding: 2px 6px;
}

.inner-card-section-collapsible {
    margin-top: 2px;
}

.inner-card-section-row {
    /*display: flex;*/
    margin-bottom: 2px;

}

.card-list-row .text {
    margin: 5px;
}

.card-list-row > i,button {
    align-self: center;
    height: max-content;
    white-space: nowrap;
}
.card-list-row > button {
    margin-right: 5px;
}
.card-list-row .text {
    text-overflow: ellipsis;
    overflow: hidden;
    min-width: 50px;
}

.fa, .fab, .fal, .far, .fas{
    line-height: 0.8 !important;

}

.col-form-label{
    font-size: 1.35rem;
    line-height: 1.4rem;
    font-weight: 500;
}

.close{
    margin-top: 0.3rem;
    margin-left: auto;
}

@media screen and (max-width: 1024px){
    .form-control {
        width: 100%;
        margin-right: 0 !important;
    }

    .btn-outline-success {
        width:100%;
        margin-top: 0.5rem !important;
    }

}

</style>
